import {
  PATIENT_CONSULTATION_STATUS,
  PatientConsultationStatus,
} from "~/common/constants";
import { PatientInformation } from "./types";

export const isPatientInScreeningStatus = (patient?: PatientInformation) => {
  if (!patient?.consultation) return true;
  const screeningStatuses: Partial<PatientConsultationStatus>[] = [
    PATIENT_CONSULTATION_STATUS.screening_not_started,
    PATIENT_CONSULTATION_STATUS.screening_started,
    PATIENT_CONSULTATION_STATUS.screening_submitted,
  ];

  return screeningStatuses.includes(patient.consultation.status);
};
